import { transformTile } from '../../movie-player/transformers/transform-tile';
import { TilesMeta } from '../../feature-player/types/tiles';

import { useFilmOtt } from './use-film-ott';

export const useTiles = (contentId: string): TilesMeta[] | undefined => {
    const film = useFilmOtt(contentId);

    return (
        film?.onlineStreams?.streams?.[0]?.streamMeta?.tilesContainer?.reduce<TilesMeta[]>(
            (acc, tile) => {
                if (tile) {
                    acc.push({
                        highRes: transformTile(tile.highResolutionTiles),
                        lowRes: transformTile(tile.lowResolutionTiles),
                        offset: tile.offset,
                    });
                }
                return acc;
            },
            []
        ) || undefined
    );
};
